export default __webpack_public_path__ + "static/media/bariyelia2.95259dda.jpg";